import { SVGProps } from 'types/common/utils'

interface Props extends SVGProps {
  orientation?: 'ASC' | 'DESC' | undefined
}

export const TableSort = (props: Props) => {
  const { className, height = 20, onClick, width = 20, orientation } = props

  const colors = {
    primary: '#191919',
    secondary: '#848484',
  }

  return (
    <svg
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      {orientation ? (
        <g id="Table sort">
          <path
            id="Polygon 1"
            d="M10 4L13.4641 8.5H6.5359L10 4Z"
            fill={orientation === 'ASC' ? colors.primary : colors.secondary}
          />
          <path
            id="Polygon 2"
            d="M10 16L13.4641 11.5H6.5359L10 16Z"
            fill={orientation === 'DESC' ? colors.primary : colors.secondary}
          />
        </g>
      ) : (
        <g id="Table sort">
          <path id="Polygon 1" d="M10 4L13.4641 8.5H6.5359L10 4Z" fill={colors.secondary} />
          <path id="Polygon 2" d="M10 16L13.4641 11.5H6.5359L10 16Z" fill={colors.secondary} />
        </g>
      )}
    </svg>
  )
}
